import { createContext, useContext, useState, useEffect } from 'react';
import ProfileAPI from '~/api/profileApi';

const UserContext = createContext();

export function UserAvatarProvider({ children }) {
    const [userAvatar, setUserAvatar] = useState({});
    const [isReloadAvatar, setIsReloadAvatar] = useState(false);

    useEffect(() => {
        ProfileAPI.getUserAvatar().then(res => setUserAvatar(res.data));
    }, [isReloadAvatar]);

    const updateAvatar =  () => {
        setIsReloadAvatar(pre => !pre);
    }

    return (
        <UserContext.Provider value={{ userAvatar, updateAvatar }}>
            {children}
        </UserContext.Provider>
    );
}

export const useUserAvatar = () => useContext(UserContext);
